import { Entity } from "./Entity";
import { Tag } from "../HTML/Tag";
import { Container } from "../HTML/Container/Container";
import { AppManager } from "./AppManager";
import { AppMenuManager } from "./AppMenuManager";
import { NavigationAppManager } from "./NavigationAppManager";
import { App } from "./App";
import { HAApp } from "./HAApp";
import { FSApp } from "./FSApp";
import type { HANavigationApp } from "./HANavigationApp";
import { toMap } from "../../../HA";

export class PageBody extends Entity {

    public getAttributes(names: string[]) {
        return this.getTag().getAttributes(names, true);
    }

    public showAppMenu(menuData: Array<Map<any, any>>) {
        this.getAppMenuManager().show(menuData);
    }

    public reloadNav(nav: HANavigationApp): void {
        this.getAppManager().reloadNav(nav);
        this.getNavigationAppManager().update(nav);
    }

    public showApp(app: App) {
        this.getNavigationAppManager().show();
        if (app instanceof HAApp) {
            this.getNavigationAppManager().update(app.getNavigation());
        } else if (app instanceof FSApp) {
            this.getNavigationAppManager().hide();
        }

        this.getAppManager().update(app);
    }

    public getAppManager(): AppManager {
        return this.get("ha.appManager");
    }

    public getAppMenuManager(): AppMenuManager {
        return this.get("ha.appMenuManager");
    }

    public getNotification() {
        return (this.getService("ha.service.webpage") as any).notification();
    }

    public getTag(): any {
        return this.get("horapp");
    }

    protected getNavigationAppManager(): NavigationAppManager {
        return this.get("ha.navigationAppManager");
    }

    protected setNavigationAppManager(navigationAppManager: NavigationAppManager) {
        return this.addToData("ha.navigationAppManager", navigationAppManager);
    }

    protected setAppManager(app: AppManager) {
        return this.addToData("ha.appManager", app);
    }

    protected setAppMenuManager(app: AppMenuManager) {
        return this.addToData("ha.appMenuManager", app);
    }

    protected initialize(data: any) {
        super.initialize(data);
        this.addToData("horapp", new Tag(toMap({attribute: "horapp"})));
        this.setNavigationAppManager(new NavigationAppManager({attribute: "navigations"}));
        this.setAppManager(new AppManager({attribute: "apps"}));
        this.setAppMenuManager(new AppMenuManager({services: this.get("services"), attribute: "appmenu"}));
        const notificationContainer = new Container({className: "hanotification"});
        this.getNotification().setMainContainer(notificationContainer);
        this.getTag().insertOnTop(notificationContainer);
    }
}
